




















import { MarketBannerAdvData } from '@/pages/home/types';
import { ubtSetupModuleExpose } from '@/shared/utils/ubt/ubt-setup';
import {
  defineComponent, onMounted, PropType, ref,
} from '@vue/composition-api';
import { advLinkJump } from '@/shared/utils/advLinkJump';
import { TP_HOME_FINANCE_CARD_ADV_BANNER } from '@/pages/home/tianqi';

export default defineComponent({
  name: 'MarketBannerAdv',
  props: {
    advData: {
      type: Object as PropType<MarketBannerAdvData>,
      required: true,
    },
  },
  setup() {
    const isLoading = ref(true);
    const closeLoading = () => {
      isLoading.value = false;
    };

    onMounted(() => {
      ubtSetupModuleExpose(TP_HOME_FINANCE_CARD_ADV_BANNER);
    });

    return {
      isLoading,
      closeLoading,
      advLinkJump,
    };
  },
});
